const SubAbasProcessosJuridicos = (id: string) => [
  {
    label: 'Dados Gerais',
    rota: `/daf/procjur/processos/ficha/${id}/dadosgerais`,
  },
  {
    label: 'Manifestação Técnica',
    rota: `/daf/procjur/processos/ficha/${id}/manifestacaotecnica`,
  },
];

export default SubAbasProcessosJuridicos;
